import { render, staticRenderFns } from "./TripPreview.vue?vue&type=template&id=1fa4de5c&"
import script from "./TripPreview.vue?vue&type=script&lang=ts&"
export * from "./TripPreview.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports